import History from "../../index"

let historyUnblock = null

const BlockNavigationReducer = (state = {show: false}, action) => {
  const {type, msg, shouldUnblock, component, unblocker} = action

  switch (type) {
    case "BLOCK_NAVIGATION_BLOCK":
      historyUnblock = History.block(msg)
      return {...state, msg, component}
    case "BLOCK_NAVIGATION_TRIGGER_CONFIRM":
      return {...state, unblocker, show: true}
    case "BLOCK_NAVIGATION_UNBLOCK":
      return unblock(state, shouldUnblock)
    case "BLOCK_NAVIGATION_UPDATE_COMPONENT":
      return {...state, component}
    default:
      return state
  }
}

export default BlockNavigationReducer

const unblock = (state, shouldUnblock) => {
  if (!state.unblocker) {
    if (historyUnblock) {
      historyUnblock()
    }
    return {}
  }

  if (shouldUnblock) {
    state.unblocker(true)
    historyUnblock()
    return {}
  }

  state.unblocker(false)
  return {...state, show: false}
}
